const formatPrice = (price: number | string) => {
    // Convertir a número si es un string
    const numericPrice = typeof price === 'string' ? parseFloat(price) : price;
    
    // Si no es un número válido, devolvemos 0
    if (isNaN(numericPrice)) return '0';

    // Formatear con separadores de miles sin decimales
    return numericPrice.toLocaleString('es-ES', {
        maximumFractionDigits: 0,
        useGrouping: true
    });
};

export default formatPrice;